import React from "react";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import styles from "../authorization.module.scss";
import { CodeIcon } from "../AuthIcons";

const cx = classNames.bind(styles);

interface VerifyEmailViewProps {
  verificationCode: string;
  codeError: boolean;
  authError: string | null;
  isLoading: boolean;
  onCodeChange: (value: string) => void;
  onResendCode: () => void;
  onBackToSignIn: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export const VerifyEmailView: React.FC<VerifyEmailViewProps> = ({
  verificationCode,
  codeError,
  authError,
  isLoading,
  onCodeChange,
  onResendCode,
  onBackToSignIn,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <form className={cx('form')} onSubmit={onSubmit}>
      <div className={cx('formHeader')}>
        <h2 className={cx('formTitle')}>{t("verifyEmail")}</h2>
        <p className={cx('formSubtitle')}>{t("enterVerificationCode")}</p>
      </div>

      {authError && <div className={cx('errorMessage')}>{t(authError)}</div>}

      <div className={cx('inputGroup')}>
        <label className={cx('inputLabel')}>{t("verificationCode")}</label>
        <div className={cx('inputWrapper', { inputError: codeError })}>
          <div className={cx('inputIcon')}>
            <CodeIcon />
          </div>
          <input
            name="code"
            type="text"
            className={cx('input')}
            placeholder={t("enterCode")}
            value={verificationCode}
            onChange={(e) => onCodeChange(e.target.value)}
          />
        </div>
        {codeError && <span className={cx('inputErrorText')}>{t("enterVerificationCode")}</span>}
      </div>

      <button type="submit" className={cx('submitButton')} disabled={isLoading}>
        {isLoading ? <span className={cx('spinner')}></span> : t("verify")}
      </button>

      <div className={cx('formLinks')}>
        <button type="button" onClick={onResendCode} className={cx('linkButton')}>
          {t("resendCode")}
        </button>
      </div>

      <div className={cx('formFooter')}>
        <button
          type="button"
          onClick={onBackToSignIn}
          className={cx('backButton')}
        >
          &larr; {t("backToSignIn")}
        </button>
      </div>
    </form>
  );
};
